//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { LocationDropPinLargeSVG } from './svg'

interface LocationDropPinLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const LocationDropPinLargeIcon: React.FC<LocationDropPinLargeIconProps> = forwardRef<
  LocationDropPinLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={LocationDropPinLargeSVG}
    sx={sx}
  />
))
